import React from 'react';

/**
 * Shared layout container — max-width 1280px, responsive horizontal padding.
 * Use this instead of repeating .xxx-container CSS patterns in every component.
 *
 * @param {string} className  Extra Tailwind classes (e.g. "py-12" for vertical padding)
 */
const Container = ({ children, className = '' }) => (
  <div className={`max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`.trim()}>
    {children}
  </div>
);

export default Container;
